//import Uiconstants from "../../lib/UIconstants"
import CloseController from '../../controllers/CloseController';
import { SettigsItem } from './SettingsItem';
import SettigsItemController from '../../controllers/settings/SettigsItemController';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import { COMPONENTS } from '../../lib/constants';
import MainGridController from '../../controllers/grid/MainGridController';
import { SettingsViewMobileGrid } from './SettingsViewMobileGrid';

export const SettingsViewMobile = {
	name: COMPONENTS.SETTINGS_PAGE,
	child: true,
	zIndex: 2,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: CloseController,
			name: 'CloseController',
			config: {
				closeBtn: 'close',
				remove: true
			}
		},
		{
			Controller: SettigsItemController,
			name: 'SettigsItemController',
			config: {
				id: 0,
				item: 'background_music_holder',
				val: 'background_music',
				texts: [
					'SETTINGS_ITEM_INFO_SFX',
					'SETTINGS_ITEM_TITLE_SFX_BG',
					'SETTINGS_ITEM_DESC_SFX_BG'
				],
				active: GameConfigs.settings.background_music,
				color: '#71B2EE'
			}
		},
		{
			Controller: SettigsItemController,
			name: 'SettigsItemController',
			config: {
				id: 1,
				item: 'fast_spin_holder',
				val: 'fast_spin',
				texts: [
					'SETTINGS_ITEM_INFO_FUNC',
					'SETTINGS_ITEM_TITLE_FUNC_RS',
					'SETTINGS_ITEM_DESC_FUNC_RS'
				],
				active: GameConfigs.settings.fast_spin,
				color: '#71EEA3'
			}
		},
		{
			Controller: SettigsItemController,
			name: 'SettigsItemController',
			config: {
				id: 2,
				item: 'keyboard_shortcuts_holder',
				val: 'keyboard_shortcuts',
				texts: [
					'SETTINGS_ITEM_INFO_VISUAL',
					'SETTINGS_ITEM_TITLE_VISUAL_KS',
					'SETTINGS_ITEM_DESC_VISUAL_KS'
				],
				active: GameConfigs.settings.keyboard_shortcuts,
				color: '#A171EE'
			}
		},
		{
			Controller: SettigsItemController,
			name: 'SettigsItemController',
			config: {
				id: 3,
				item: 'sound_effects_holder',
				val: 'sound_effects',
				texts: [
					'SETTINGS_ITEM_INFO_SFX',
					'SETTINGS_ITEM_TITLE_SFX_SE',
					'SETTINGS_ITEM_DESC_SFX_SE'
				],
				active: GameConfigs.settings.sound_effects,
				color: '#EE718F'
			}
		},
		{
			Controller: SettigsItemController,
			name: 'SettigsItemController',
			config: {
				id: 4,
				item: 'game_animation_holder',
				val: 'game_animation',
				texts: [
					'SETTINGS_ITEM_INFO_FUNC',
					'SETTINGS_ITEM_TITLE_FUNC_GA',
					'SETTINGS_ITEM_DESC_FUNC_GA'
				],
				active: GameConfigs.settings.game_animation,
				color: '#EE9E71'
			}
		},
		{
			Controller: SettigsItemController,
			name: 'SettigsItemController',
			config: {
				id: 5,
				item: 'splash_screen_holder',
				val: 'splash_screen',
				texts: [
					'SETTINGS_ITEM_INFO_VISUAL',
					'SETTINGS_ITEM_TITLE_FUNC_SS',
					'SETTINGS_ITEM_DESC_SS_DESC'
				],
				active: GameConfigs.settings.splash_screen,
				color: '#EE71B5'
			}
		},
		{
			Controller: MainGridController,
			name: 'SettingsViewMobileGrid',
			config: SettingsViewMobileGrid
		}
	],
	components: [
		{
			name: 'settings_page_main_bg',
			type: 'Sprite',
			img: 'reel_bg'
		},
		{
			name: 'background_music_holder',
			type: 'Sprite',
			components: [
				{
					name: 'background_music',
					type: 'VisualComponent',
					component: SettigsItem
				}
			]
		},
		{
			name: 'fast_spin_holder',
			type: 'Sprite',
			components: [
				{
					name: 'fast_spin',
					type: 'VisualComponent',
					component: SettigsItem
				}
			]
		},
		{
			name: 'keyboard_shortcuts_holder',
			type: 'Sprite',
			components: [
				{
					name: 'keyboard_shortcuts',
					type: 'VisualComponent',
					component: SettigsItem
				}
			]
		},
		{
			name: 'sound_effects_holder',
			type: 'Sprite',
			components: [
				{
					name: 'sound_effects',
					type: 'VisualComponent',
					component: SettigsItem
				}
			]
		},
		{
			name: 'game_animation_holder',
			type: 'Sprite',
			components: [
				{
					name: 'game_animation',
					type: 'VisualComponent',
					component: SettigsItem
				}
			]
		},
		{
			name: 'splash_screen_holder',
			type: 'Sprite',
			components: [
				{
					name: 'splash_screen',
					type: 'VisualComponent',
					component: SettigsItem
				}
			]
		},
		{
			name: 'header',
			type: 'Text',
			text: 'SETTINGS_PAGE_HEADER',
			position: {
				x: 0,
				y: -10
			}
		},
		{
			name: 'close',
			type: 'SimpleButton',
			components: [
				{
					name: 'xxxxx',
					type: 'MouseOverSprite',
					img: 'close_icon',
					imgHover: 'close_icon_hovered',
					position: {
						x: 0,
						y: 0
					}
				}
			]
		}
	]
};
